import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-indorse-extension',
  template: `
    <p>
      indorse-extension works!
    </p>
  `,
  styles: []
})
export class IndorseExtensionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
